/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 */

import SocialBanner from './SocialBanner';

export default SocialBanner;
